module.exports = __webpack_public_path__ + "img/top-bg-img-1.25ac309c.png";